import intl from 'react-intl-universal';
import { isLoadCompositionFlowBrewerySide } from 'utils/validations-general-settings';

export const getObservationLabel = () => isLoadCompositionFlowBrewerySide() ? intl.get('commons.breweryNote')  : intl.get('commons.supplierNote');

export const getObservationLabelAbbreviated = () => isLoadCompositionFlowBrewerySide() ? intl.get('commons.breweryNoteAbbreviated') : intl.get('commons.supplierNoteAbbreviated');

export const getObservationValue = (breweryNote, supplierNote) => isLoadCompositionFlowBrewerySide() ? breweryNote : supplierNote;
